(function () {
  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function money(value, format) {
    var numeric = Number(value);
    if (!Number.isFinite(numeric)) return value || '';

    var cents = Math.round(numeric * 100);
    var placeholder = (format.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
    var decimal = '.';
    var thousands = ',';
    var precision = 2;

    if (placeholder === 'amount_no_decimals') precision = 0;
    if (placeholder === 'amount_with_comma_separator') {
      decimal = ',';
      thousands = '.';
    }
    if (placeholder === 'amount_no_decimals_with_comma_separator') {
      precision = 0;
      decimal = ',';
      thousands = '.';
    }
    if (placeholder === 'amount_with_apostrophe_separator') thousands = "'";

    var number = (cents / 100).toFixed(precision);
    var pieces = number.split('.');
    pieces[0] = pieces[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var output = pieces[0] + (pieces[1] ? decimal + pieces[1] : '');
    return format.replace(/\{\{\s*\w+\s*\}\}/, output);
  }

  function imageUrl(image) {
    if (!image) return '';
    var url = typeof image === 'string' ? image : image.url || image.src || '';
    if (!url) return '';
    return url.replace(/(\.[a-zA-Z]{3,4})(\?.*)?$/, '_96x$1$2');
  }

  function initHeader(root) {
    if (!root || root.getAttribute('data-sh-ready') === 'true') return;
    root.setAttribute('data-sh-ready', 'true');

    var items = toArray(root.querySelectorAll('[data-sh-item]'));
    var drawer = root.querySelector('[data-sh-drawer]');
    var openBtn = root.querySelector('[data-sh-open-drawer]');
    var closeBtns = toArray(root.querySelectorAll('[data-sh-close-drawer]'));
    var searchWrap = root.querySelector('[data-sh-search]');
    var searchForm = root.querySelector('[data-sh-search-form]');
    var searchInput = root.querySelector('[data-sh-search-input]');
    var searchType = root.querySelector('[data-sh-search-type]');
    var predictive = root.querySelector('[data-sh-predictive]');
    var defaultPanel = root.querySelector('[data-sh-default]');
    var livePanel = root.querySelector('[data-sh-live]');
    var predictiveList = root.querySelector('[data-sh-predictive-list]');
    var predictiveStatus = root.querySelector('[data-sh-predictive-status]');
    var predictiveAll = root.querySelector('[data-sh-predictive-all]');
    var tabs = toArray(root.querySelectorAll('[data-sh-tab]'));
    var popularBtns = toArray(root.querySelectorAll('[data-sh-popular]'));
    var predictiveUrl = root.getAttribute('data-predictive-url') || '';
    var searchUrl = root.getAttribute('data-search-url') || '/search';
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var seeAllLabel = root.getAttribute('data-see-all-label') || 'See all results for';
    var noResultsText = root.getAttribute('data-no-results') || 'No matches found.';
    var loadingText = root.getAttribute('data-loading-text') || 'Searching…';
    var limit = parseInt(root.getAttribute('data-predictive-limit') || '6', 10);
    var minChars = parseInt(root.getAttribute('data-min-chars') || '2', 10);
    var activeTab = 'product';
    var closeTimer = null;
    var controller = null;
    var cache = new Map();

    function closeAllMegas(except) {
      items.forEach(function (item) {
        if (except && item === except) return;
        var trigger = item.querySelector('[data-sh-trigger]');
        var mega = item.querySelector('[data-sh-mega]');
        item.classList.remove('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (mega) {
          mega.hidden = true;
          mega.setAttribute('hidden', '');
        }
      });
    }

    function openMega(item) {
      closeAllMegas(item);
      var trigger = item.querySelector('[data-sh-trigger]');
      var mega = item.querySelector('[data-sh-mega]');
      item.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (mega) {
        mega.hidden = false;
        mega.removeAttribute('hidden');
      }
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        closeAllMegas();
      }, 220);
    }

    function cancelClose() {
      clearTimeout(closeTimer);
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-sh-trigger]');
      var mega = item.querySelector('[data-sh-mega]');
      if (!trigger || !mega) return;

      item.addEventListener('mouseenter', function () {
        if (window.matchMedia('(max-width: 989px)').matches) return;
        cancelClose();
        openMega(item);
      });

      item.addEventListener('mouseleave', function () {
        if (window.matchMedia('(max-width: 989px)').matches) return;
        scheduleClose();
      });

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var isOpen = item.classList.contains('is-open');
        if (isOpen) closeAllMegas();
        else openMega(item);
      });
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closeAllMegas();
      else if (!event.target.closest('[data-sh-item]')) closeAllMegas();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAllMegas();
        closeDrawer();
        hidePredictive();
      }
    });

    function syncDrawerTop() {
      if (!drawer || drawer.hidden) return;
      var announce = root.querySelector('[data-sh-announce]');
      var bar = root.querySelector('[data-sh-sticky-bar]');
      var top = 0;
      if (announce) top = Math.max(top, announce.getBoundingClientRect().bottom);
      if (bar) top = Math.max(top, bar.getBoundingClientRect().bottom);
      root.style.setProperty('--sh-drawer-top', Math.max(0, Math.round(top)) + 'px');
    }

    function setOpenBtnLabel(isOpen) {
      if (!openBtn) return;
      openBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      openBtn.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    }

    function openDrawer() {
      if (!drawer) return;
      drawer.hidden = false;
      drawer.removeAttribute('hidden');
      document.documentElement.classList.add('sh-drawer-open');
      root.classList.add('sh--drawer-open');
      root.classList.remove('sh--sticky-hidden');
      setOpenBtnLabel(true);
      syncDrawerTop();
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.hidden = true;
      drawer.setAttribute('hidden', '');
      document.documentElement.classList.remove('sh-drawer-open');
      root.classList.remove('sh--drawer-open');
      setOpenBtnLabel(false);
    }

    function isDrawerOpen() {
      return !!(drawer && !drawer.hidden && !drawer.hasAttribute('hidden'));
    }

    if (openBtn) {
      openBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (isDrawerOpen()) closeDrawer();
        else openDrawer();
      });
    }

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeDrawer();
      });
    });

    window.addEventListener('resize', syncDrawerTop);
    window.addEventListener('scroll', function () {
      if (root.classList.contains('sh--drawer-open')) syncDrawerTop();
    }, { passive: true });

    function setExpanded(open) {
      if (searchInput) searchInput.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function showDefaultPanel() {
      if (!predictive) return;
      predictive.hidden = false;
      if (defaultPanel) defaultPanel.hidden = false;
      if (livePanel) livePanel.hidden = true;
      setExpanded(true);
      syncPopularActive('');
    }

    function showLivePanel() {
      if (!predictive) return;
      predictive.hidden = false;
      if (defaultPanel) defaultPanel.hidden = true;
      if (livePanel) livePanel.hidden = false;
      setExpanded(true);
    }

    function hidePredictive() {
      if (!predictive) return;
      predictive.hidden = true;
      setExpanded(false);
      if (predictiveStatus) {
        predictiveStatus.hidden = true;
        predictiveStatus.textContent = '';
      }
      if (predictiveList) predictiveList.innerHTML = '';
      if (predictiveAll) predictiveAll.hidden = true;
      syncPopularActive('');
    }

    function syncPopularActive(query) {
      var needle = (query || '').trim().toLowerCase();
      popularBtns.forEach(function (btn) {
        var value = (btn.getAttribute('data-sh-popular') || '').toLowerCase();
        btn.classList.toggle('is-active', !!needle && value === needle);
      });
    }

    function setTab(tab) {
      activeTab = tab === 'article' ? 'article' : 'product';
      if (searchType) searchType.value = activeTab === 'article' ? 'article' : 'product';
      tabs.forEach(function (btn) {
        var on = btn.getAttribute('data-sh-tab') === activeTab;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var query = (searchInput && searchInput.value) || '';
      if (query.trim().length >= minChars) runPredictive(query);
      else showDefaultPanel();
    }

    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTab(btn.getAttribute('data-sh-tab'));
      });
    });

    function showStatus(msg) {
      showLivePanel();
      if (predictiveStatus) {
        predictiveStatus.hidden = !msg;
        predictiveStatus.textContent = msg || '';
      }
      if (predictiveList) predictiveList.innerHTML = '';
      if (predictiveAll) predictiveAll.hidden = true;
    }

    function mapResults(payload, type) {
      var resources = (payload && payload.resources && payload.resources.results) || {};
      if (type === 'article') {
        return (resources.articles || []).map(function (article) {
          return {
            kind: 'article',
            title: article.title,
            url: article.url,
            image: imageUrl(article.image || article.featured_image),
            price: null,
          };
        });
      }
      return (resources.products || []).map(function (product) {
        return {
          kind: 'product',
          title: product.title,
          url: product.url,
          image: imageUrl(product.featured_image || product.image),
          price: product.price,
        };
      });
    }

    function renderLive(results, query) {
      showLivePanel();
      if (predictiveStatus) {
        predictiveStatus.hidden = true;
        predictiveStatus.textContent = '';
      }
      if (!predictiveList) return;
      predictiveList.innerHTML = '';

      if (!results.length) {
        showStatus(noResultsText);
        if (predictiveAll) {
          predictiveAll.hidden = false;
          predictiveAll.href =
            searchUrl +
            '?type=' +
            encodeURIComponent(activeTab === 'article' ? 'article' : 'product') +
            '&q=' +
            encodeURIComponent(query);
          predictiveAll.textContent = seeAllLabel + ' “' + query + '”';
        }
        return;
      }

      results.forEach(function (item) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'sh__predictive-item';
        a.href = item.url;

        if (item.image) {
          var img = document.createElement('img');
          img.src = item.image;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 48;
          img.height = 48;
          a.appendChild(img);
        }

        var meta = document.createElement('span');
        meta.className = 'sh__predictive-meta';
        var title = document.createElement('span');
        title.className = 'sh__predictive-title';
        title.textContent = item.title;
        meta.appendChild(title);

        if (item.kind === 'product' && item.price !== undefined && item.price !== null) {
          var price = document.createElement('span');
          price.className = 'sh__predictive-price';
          price.textContent = money(item.price, moneyFormat);
          meta.appendChild(price);
        }

        a.appendChild(meta);
        li.appendChild(a);
        predictiveList.appendChild(li);
      });

      if (predictiveAll) {
        predictiveAll.hidden = false;
        predictiveAll.href =
          searchUrl +
          '?type=' +
          encodeURIComponent(activeTab === 'article' ? 'article' : 'product') +
          '&q=' +
          encodeURIComponent(query);
        predictiveAll.textContent = seeAllLabel + ' “' + query + '”';
      }
    }

    function runPredictive(raw) {
      var query = (raw || '').trim();
      syncPopularActive(query);

      if (query.length < minChars) {
        if (document.activeElement === searchInput) showDefaultPanel();
        else hidePredictive();
        return;
      }

      if (!predictiveUrl) {
        showStatus(noResultsText);
        return;
      }

      var cacheKey = activeTab + ':' + query.toLowerCase();
      if (cache.has(cacheKey)) {
        renderLive(cache.get(cacheKey), query);
        return;
      }

      if (controller) controller.abort();
      controller = new AbortController();
      showStatus(loadingText);

      var params = new URLSearchParams();
      params.set('q', query);
      params.set('resources[type]', activeTab === 'article' ? 'article' : 'product');
      params.set('resources[limit]', String(limit || 6));
      if (activeTab === 'product') {
        params.set('resources[options][unavailable_products]', 'last');
        params.set(
          'resources[options][fields]',
          'title,product_type,variants.title,variants.sku,vendor,tag'
        );
      }

      fetch(predictiveUrl + '?' + params.toString(), {
        signal: controller.signal,
        headers: { Accept: 'application/json' },
      })
        .then(function (response) {
          if (!response.ok) throw new Error('search-failed');
          return response.json();
        })
        .then(function (payload) {
          var mapped = mapResults(payload, activeTab);
          cache.set(cacheKey, mapped);
          renderLive(mapped, query);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          showStatus('Search unavailable. Press Enter to search.');
          if (predictiveAll) {
            predictiveAll.hidden = false;
            predictiveAll.href =
              searchUrl +
              '?type=' +
              encodeURIComponent(activeTab === 'article' ? 'article' : 'product') +
              '&q=' +
              encodeURIComponent(query);
            predictiveAll.textContent = seeAllLabel + ' “' + query + '”';
          }
        });
    }

    var debouncedPredictive = debounce(runPredictive, 260);

    function applyPopular(query) {
      if (!searchInput) return;
      searchInput.value = query;
      syncPopularActive(query);
      searchInput.focus();
      setTab('product');
      runPredictive(query);
    }

    popularBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyPopular(btn.getAttribute('data-sh-popular') || btn.textContent || '');
      });
    });

    if (searchInput && predictive) {
      searchInput.addEventListener('focus', function () {
        var query = (searchInput.value || '').trim();
        if (query.length >= minChars) runPredictive(query);
        else showDefaultPanel();
      });

      searchInput.addEventListener('click', function () {
        var query = (searchInput.value || '').trim();
        if (query.length >= minChars) runPredictive(query);
        else showDefaultPanel();
      });

      searchInput.addEventListener('input', function () {
        var query = (searchInput.value || '').trim();
        if (query.length >= minChars) debouncedPredictive(searchInput.value);
        else showDefaultPanel();
      });

      if (searchWrap) {
        searchWrap.addEventListener('mousedown', function (event) {
          if (event.target.closest('.sh__predictive')) return;
          // keep panel open when interacting with search chrome
        });
      }

      document.addEventListener('click', function (event) {
        if (searchWrap && !searchWrap.contains(event.target)) hidePredictive();
      });
    }

    if (searchForm) {
      searchForm.addEventListener('submit', function (event) {
        if (!searchInput || !(searchInput.value || '').trim()) {
          event.preventDefault();
          searchInput.focus();
          showDefaultPanel();
        }
      });
    }

    initSticky(root);
  }

  function initSticky(root) {
    var mode = root.getAttribute('data-sticky') || 'off';
    if (mode === 'off') return;

    var scope = root.getAttribute('data-sticky-scope') || 'full';
    var offset = parseInt(root.getAttribute('data-sticky-offset') || '80', 10);
    var bar = root.querySelector('[data-sh-sticky-bar]');
    if (!bar) return;

    var spacer = root.querySelector('[data-sh-sticky-spacer]');
    if (!spacer) {
      spacer = document.createElement('div');
      spacer.className = 'sh__sticky-spacer';
      spacer.setAttribute('data-sh-sticky-spacer', '');
      bar.parentNode.insertBefore(spacer, bar.nextSibling);
    }

    root.classList.add('sh--sticky-ready');
    root.classList.toggle('sh--scope-nav', scope === 'nav');

    var lastY = window.pageYOffset || 0;
    var ticking = false;

    function stickyHeight() {
      if (scope === 'nav') {
        var nav = root.querySelector('.sh__nav');
        return nav ? nav.offsetHeight : 0;
      }
      return bar.offsetHeight;
    }

    function setSpacer(active) {
      if (!active) {
        root.classList.remove('sh--has-spacer');
        spacer.style.height = '0px';
        return;
      }
      spacer.style.height = stickyHeight() + 'px';
      root.classList.add('sh--has-spacer');
    }

    function applyState(y) {
      var scrollingDown = y > lastY;
      var past = y > offset;
      var drawerOpen = root.classList.contains('sh--drawer-open');

      if (mode === 'always') {
        root.classList.toggle('sh--is-sticky', past || y > 8);
        root.classList.remove('sh--sticky-hidden');
        setSpacer(root.classList.contains('sh--is-sticky'));
      } else if (mode === 'scroll_down') {
        // Stick after offset; stay visible while scrolling down.
        root.classList.toggle('sh--is-sticky', past);
        root.classList.remove('sh--sticky-hidden');
        setSpacer(past);
      } else if (mode === 'scroll_up') {
        if (!past) {
          root.classList.remove('sh--is-sticky', 'sh--sticky-hidden');
          setSpacer(false);
        } else {
          root.classList.add('sh--is-sticky');
          root.classList.toggle('sh--sticky-hidden', !drawerOpen && scrollingDown && y - lastY > 2);
          if (!scrollingDown || drawerOpen) root.classList.remove('sh--sticky-hidden');
          setSpacer(true);
        }
      }

      lastY = y;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        applyState(window.pageYOffset || 0);
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      if (root.classList.contains('sh--is-sticky')) setSpacer(true);
    });
    applyState(window.pageYOffset || 0);
  }

  function boot() {
    toArray(document.querySelectorAll('[data-sh]')).forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    toArray(event.target.querySelectorAll('[data-sh]')).forEach(function (el) {
      el.removeAttribute('data-sh-ready');
      initHeader(el);
    });
  });
})();
